/* global window, document, fetch */
/**
 * Lampadina kanban: on/off da `in_kanban` sul dato tender (gateway); toggle con POST /kanban/toggle.
 * Header X-Member-UUID = stesso valore di data-member-uuid in pagina (lista / mappa / radar).
 */
(function (window, document) {
    function apiRoot(anchorEl) {
        var el = null;
        if (anchorEl && typeof anchorEl.closest === 'function') {
            el = anchorEl.closest('[data-api-base]');
        }
        if (!el) {
            el =
                document.querySelector('#appaltimap-map[data-api-base]') ||
                document.querySelector('[data-vg-funding-map][data-api-base]') ||
                document.querySelector('[data-api-base]');
        }
        var base = (el && el.getAttribute('data-api-base')) || '/api';
        return String(base).replace(/\/+$/, '');
    }

    function memberUuidForNode(node) {
        if (node && typeof node.closest === 'function') {
            var n = node.closest('[data-member-uuid]');
            if (n) {
                var u = (n.getAttribute('data-member-uuid') || '').trim();
                if (u) return u;
            }
        }
        var m =
            document.querySelector('#appaltimap-map[data-member-uuid]') ||
            document.querySelector('[data-vg-funding-map][data-member-uuid]') ||
            document.querySelector('[data-member-uuid]');
        return m ? (m.getAttribute('data-member-uuid') || '').trim() : '';
    }

    function lampHeaders(memberUuid) {
        var h = { Accept: 'application/json' };
        if (memberUuid) {
            h['X-Member-UUID'] = memberUuid;
        }
        return h;
    }

    function escAttr(s) {
        return String(s || '')
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;');
    }

    function deadlineRaw(row) {
        if (!row) return '';
        var d = row.tender_period_end || row.deadline_date || row.tender_deadline || row.deadline;
        return d ? String(d).trim() : '';
    }

    function deadlineMs(row) {
        var s = deadlineRaw(row);
        if (!s) return null;
        var t = new Date(s).getTime();
        return isFinite(t) ? t : null;
    }

    /** Allineato a Postgres: deadline nota e >= oggi (senza scadenza = bando non idoneo). */
    function isFundingDeadlineOpen(row) {
        var s = deadlineRaw(row);
        if (!s) return false;
        var m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) {
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var dl = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
            return dl.getTime() >= today.getTime();
        }
        var t = deadlineMs(row);
        if (t == null) return false;
        return t >= Date.now();
    }

    function isFundingRow(row) {
        var pid = row && row.procedure_id ? String(row.procedure_id).trim() : '';
        return pid.indexOf('funding:') === 0;
    }

    function isRegionalProcedureRow(row) {
        if (!row) return false;
        var src = String(row.source || '');
        if (src.indexOf('regional_') === 0) return true;
        var pid = String(row.procedure_id || '');
        return pid.indexOf('regional:') === 0;
    }

    function isRowOpenForLamp(row) {
        if (!row || !row.procedure_id) return false;
        if (isRegionalProcedureRow(row)) {
            var stR = String(row.status || '').toLowerCase();
            if (stR === 'awarded' || stR === 'cancelled' || stR === 'unsuccessful' || stR === 'no_bids') {
                return false;
            }
            var tR = deadlineMs(row);
            if (tR != null) return tR >= Date.now();
            return true;
        }
        if (isFundingRow(row)) {
            var st = String(row.status || '').toUpperCase();
            if (!st || st !== 'OPEN') return false;
            return isFundingDeadlineOpen(row);
        }
        var st = String(row.status || '').toLowerCase();
        if (st === 'awarded' || st === 'cancelled' || st === 'unsuccessful') return false;
        var t = deadlineMs(row);
        if (t == null) return false;
        return t >= Date.now();
    }

    function lampButtonHtml(row) {
        var pid = row && row.procedure_id ? String(row.procedure_id).trim() : '';
        if (!pid) return '';
        var pidEnc = encodeURIComponent(pid);
        var open = isRowOpenForLamp(row);
        var on = !!row.in_kanban;
        if (!open) {
            return (
                '<button type="button" class="vg-kanban-lamp vg-kanban-lamp--off vg-kanban-lamp--disabled" disabled ' +
                'data-vg-kanban-lamp aria-pressed="false" aria-label="Bando non idoneo per Kanban" ' +
                'title="Bando chiuso o scaduto" data-procedure-id="' +
                escAttr(pidEnc) +
                '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
                '<path fill="currentColor" d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 017 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"/>' +
                '</svg></button>'
            );
        }
        return (
            '<button type="button" class="vg-kanban-lamp ' +
            (on ? 'vg-kanban-lamp--on' : 'vg-kanban-lamp--off') +
            '" data-vg-kanban-lamp ' +
            'aria-pressed="' +
            (on ? 'true' : 'false') +
            '" aria-label="Segnale" data-procedure-id="' +
            escAttr(pidEnc) +
            '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
            '<path fill="currentColor" d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 017 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"/>' +
            '</svg></button>'
        );
    }

    function formatterCell(row) {
        return lampButtonHtml(row);
    }

    function normPid(s) {
        return String(s || '').trim();
    }

    /** Abilita/disabilita i bottoni se manca data-member-uuid (nessun toggle senza identità). */
    function applyLampMemberGate(tableEl) {
        if (!tableEl || !tableEl.isConnected) return;
        var live = tableEl.querySelectorAll('[data-vg-kanban-lamp][data-procedure-id]');
        if (!live || !live.length) return;
        var mem = memberUuidForNode(tableEl);
        if (!mem) {
            Array.prototype.forEach.call(live, function (b) {
                b.disabled = true;
                b.setAttribute('disabled', 'disabled');
                b.classList.add('vg-kanban-lamp--disabled');
            });
            return;
        }
        Array.prototype.forEach.call(live, function (b) {
            b.disabled = false;
            b.removeAttribute('disabled');
            b.classList.remove('vg-kanban-lamp--disabled');
        });
    }

    function syncTable(tableEl) {
        applyLampMemberGate(tableEl);
        return Promise.resolve();
    }

    function tabulatorMountEl(tab) {
        if (!tab) return null;
        // Tabulator 6: root DOM is `table.element`. Older code used `getElement()` on row/column/cell only.
        if (tab.element && tab.element.nodeType === 1) return tab.element;
        if (typeof tab.getElement === 'function') {
            try {
                return tab.getElement();
            } catch (eG) {}
        }
        return null;
    }

    function wireTabulator(tab) {
        if (!tab || typeof tab.on !== 'function') return;
        if (tab._vgKanbanLampWiredListener) return;
        tab._vgKanbanLampWiredListener = true;
        var run = function () {
            var el = tabulatorMountEl(tab);
            if (!el) return;
            window.setTimeout(function () {
                try {
                    applyLampMemberGate(el);
                } catch (e) {}
            }, 0);
            window.setTimeout(function () {
                try {
                    applyLampMemberGate(el);
                } catch (e2) {}
            }, 120);
        };
        tab.on('dataLoaded', run);
        try {
            tab.on('pageLoaded', run);
        } catch (e2) {}
        try {
            tab.on('renderComplete', run);
        } catch (e3) {}
    }

    document.addEventListener(
        'click',
        function (ev) {
            var t = ev.target;
            if (!t || !t.closest) return;
            var btn = t.closest('[data-vg-kanban-lamp]');
            if (!btn || btn.disabled) return;
            ev.preventDefault();
            ev.stopPropagation();
            var rawP = (btn.getAttribute('data-procedure-id') || '').trim();
            var pid = '';
            try {
                pid = rawP ? normPid(decodeURIComponent(rawP)) : '';
            } catch (ePid) {
                pid = normPid(rawP);
            }
            if (!pid) return;
            var mem = memberUuidForNode(btn);
            if (!mem) {
                btn.classList.add('vg-kanban-lamp--pulse-error');
                window.setTimeout(function () {
                    btn.classList.remove('vg-kanban-lamp--pulse-error');
                }, 900);
                return;
            }
            fetch(apiRoot(btn) + '/kanban/toggle', {
                method: 'POST',
                credentials: 'include',
                headers: Object.assign({ 'Content-Type': 'application/json' }, lampHeaders(mem)),
                body: JSON.stringify({ procedure_id: pid })
            })
                .then(function (r) {
                    return r.json().then(function (j) {
                        return { r: r, j: j };
                    });
                })
                .then(function (x) {
                    if (!x.r.ok) {
                        var d = x.j && x.j.detail;
                        throw new Error(typeof d === 'string' ? d : JSON.stringify(d || {}));
                    }
                    var added = !!x.j.added;
                    var removed = !!x.j.removed;
                    var on = added && !removed;
                    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
                    btn.classList.toggle('vg-kanban-lamp--on', on);
                    btn.classList.toggle('vg-kanban-lamp--off', !on);
                    try {
                        document.dispatchEvent(
                            new CustomEvent('vg-kanban-updated', {
                                bubbles: true,
                                detail: { procedure_id: pid }
                            })
                        );
                    } catch (eEv) {}
                })
                .catch(function (err) {
                    btn.classList.add('vg-kanban-lamp--pulse-error');
                    window.setTimeout(function () {
                        btn.classList.remove('vg-kanban-lamp--pulse-error');
                    }, 900);
                    var msg = (err && err.message) ? String(err.message) : 'Operazione non riuscita';
                    if (window.VistaGareUi && window.VistaGareUi.alert) {
                        window.VistaGareUi.alert(msg, { title: 'Kanban' });
                    }
                });
        },
        true
    );

    window.VistaGareKanbanLamp = {
        formatterCell: formatterCell,
        syncTable: syncTable,
        wireTabulator: wireTabulator
    };
})(window, document);
